// ui/headline-parts.js: BATCH B4b-1 U5.
//
// At 375x667 the recap headline "We got euchred — THEM +2" wrapped with
// "+2" alone on the last line. The modal draws the closing "THEM +2" as
// one unbreakable chunk, so the points always stay with their team word.

/**
 * Split a recap headline into its words and its closing points chunk
 * ("US +2" / "THEM +1"). A headline without points is all lead.
 *
 * @param {string} headline
 * @returns {{lead: string, points: string}}
 */
export function headlineParts(headline) {
  const m = /(US|THEM) \+\d+$/.exec(headline || '');
  if (!m) return { lead: headline || '', points: '' };
  return { lead: headline.slice(0, m.index), points: m[0] };
}
